import React, {Component} from 'react'
import {PortfolioContext} from './../contexts/recentsWorks';
// import img1 from './../images/projects/violaInteractive/all-landingPage.png'
// import img2 from './../images/projects/violaInteractive/coverOne.png';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import {IoCheckmarkDoneCircleSharp,IoArrowBackSharp, IoEye} from "react-icons/io5";
import Loading from './../components/Loading';
import Fancybox from './../components/Fancybox.js'
import {Helmet} from "react-helmet";
export default class ProjectsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            slug: this.props.match.params.slug,
            skills:[]
        }
    }

    static contextType = PortfolioContext;


    render() {

        const {getSlug, loading} = this.context;
        const project = getSlug(this.state.slug)
        if (!project) {
            return <Loading/>
        }
        return (loading
            ? <Loading/>
            : <> <div className="single-project">
                 <Helmet>
                <meta charSet="utf-8" />
                <title>Mostafa Abdelazeem - About me</title>
                <meta name="description" content="I'm a senior Front-End Developer with +5 years of experience and Extensive Experience in the Design, Development, and maintenance of the website to fix responsive and other issues, I have Extensive Skills in HTML5, CSS3, Javascript,3D Animation using Three.js, and 2d Animation with GSAP, and Responsive"></meta>
                <meta name="keywords" content=""></meta>
                <meta name="robots" content="index, follow"/>
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Mostafa Abdelazeem" />
                <meta property="og:description" content="I'm a senior Front-End Developer with 3+ years of experience and Extensive Experience in the Design, Development, and maintenance of the website to fix responsive and other issues, I have Extensive Skills in HTML5, CSS3, Javascript,3D Animation using Three.js, and 2d Animation with GSAP, and Responsive" />
                <meta property="og:image" content="http://moabdo.netlify.app/static/media/hero.5c32137d.jpg" />
                <meta property="og:url" content="https://moabdo.netlify.app/" />
                <meta property="og:site_name" content="Mostafa Abdelazeem - Portfolio" />
            </Helmet>
            {console.log(project)}
                <div className="container">
                <div className='flex-between'>
                    <div className='backProject' onClick={()=>this.props.history.goBack()}>
                        <IoArrowBackSharp/>
                    </div>
                    <a href={`${project.link}`} target='_blank' className='btn-live'>
                        Live site <IoEye />
                    </a>
                </div>
                
                    <div className="single-project--wrapper">
                        <Grid container>
                            <Grid item xs={12} sm={6}>
                                <div className="text-container">
                                    <h2>{project.name}</h2>
                                    <h6 className='white_space'>{project.description}</h6>
                                </div>
                                {project.forSale
                                    ? <div className="text-container offerBackground">
                                            <div className='exclusive-part'>
                                                <div className="price">
                                                    <span className="afterSale">{project.priceAfterSale}LE</span>
                                                    <span className="beforeSale">{project.price}LE</span>
                                                </div>
                                                <div className="right">
                                                    <div className="save">Save {project.salePercent}%</div>
                                                    <div className="offer">with chat feature</div>
                                                </div>
                                                <div className="buy-btn">
                                                    {/* <div
                                                        className='btn-primary'
                                                        style={{
                                                        backgroundColor: '#d04848',
                                                        color: '#ffffff'
                                                    }}>Buy Now</div> */}
                                                </div>
                                            </div>
                                        </div>
                                    : <div></div>
}
                                <div className="text-container">

                                    <h5 className='mb-5'>Developed By</h5>
                                    <h6 className='mt--5'>
                                        {
                                            project.developerName ? 
                                            <span style={{
                                                fontSize: "12px",
                                                color: "#767779"
                                            }}>
                                                {project.developerName}
                                            </span>
                                            :
                                            <span>Me - Mostafa abdelazeemsad </span>
                                        }
                                     
                                    </h6>
                                    <div className=' mb-10'>
                                        <h5 className='mb-5'>Developed</h5>
                                        {project.developed
                                            ? <div>
                                                    <Chip
                                                        size="small"
                                                        icon={< IoCheckmarkDoneCircleSharp />}
                                                        color="primary"
                                                        label='Developed'/>
                                                    <Chip size="small" disabled color="secondary" label='Not Developed '/>
                                                </div>
                                            : <div>
                                                <Chip disabled size="small" color="primary" label='Developed'/>
                                                <Chip
                                                    size="small"
                                                    icon={< IoCheckmarkDoneCircleSharp />}
                                                    color="secondary"
                                                    label='Not Developed '/>
                                            </div>
}
                                    </div>
                                    <h5 className='mb-5'>Designed By</h5>
                                    <h6>{project.uiDesignerName}</h6>
                                    <h5 className='mb-5'>For Sale</h5>
                                    {project.forSale
                                        ? <div>
                                                <Chip
                                                    size="small"
                                                    icon={< IoCheckmarkDoneCircleSharp />}
                                                    className='MuiChip-success'
                                                    label='For Sale'/>
                                            </div>
                                        : <div>
                                            <Chip size="small" icon={< IoCheckmarkDoneCircleSharp />} label='Sold'/>
                                        </div>
}
                                </div>
                                <div className="text-container technologies">
                                    <h5>Technologies used</h5>
                                    {project
                                        .projectSkills
                                        .map((skill, index) => {
                                            return (
                                                    <Chip color="secondary" size="small" key={index} label={skill}/>
                                                   
                                            )
                                        })
}
                                </div>
                                <div className="text-container copyrights">
                                    <h5>Copyrights</h5>
                                    <p>{project.copyrights}</p>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className="images-container">
                                    <h2>{project.name}</h2>
                                    <div className="images-wrapper">
                                 
                                        <div className="row">
                                            {
                                            project
                                                .images
                                                .map((image, index) => {
                                                    return (
                                                        <div key={index} className="item">
                                                            <Fancybox>
  
                                                            <a data-fancybox="recentWorks" href={image.file.url}>
                                                                <img src={image.file.url} alt={image.title}/>
                                                            </a>
                                                        </Fancybox>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div> </>
        )
    }
}